import { liveOnly, type LiveImportantDate } from '@wiztime/core';
import { queries } from '@wiztime/storage';
import { useLive, type LiveResult } from '../../hooks/useLive';
import { useStore } from '../../hooks/useServices';

/** Every live important date (deactivated ones included), loading and error state included. */
export function useImportantDates(): LiveResult<LiveImportantDate[]> {
  const store = useStore();
  return useLive(async () => liveOnly(await queries.importantDates(store.repo)), [store]);
}
